"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

require("./index.css");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Header = function Header(_ref) {
  var logo = _ref.logo,
      hamburger = _ref.hamburger;
  var headerRef = (0, _react.useRef)(null);

  var handleDocumentScroll = function handleDocumentScroll() {
    var wScroll = window.scrollY;

    if (wScroll > 40) {
      headerRef.current.classList.add('header--scroll');
    } else {
      headerRef.current.classList.remove('header--scroll');
    }
  };

  (0, _react.useEffect)(function () {
    window.addEventListener('scroll', handleDocumentScroll);
    return function () {
      return window.removeEventListener('scroll', handleDocumentScroll);
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("header", {
    ref: headerRef
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "container-fluid"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row justify-content-between align-items-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-md-2 col-sm-6 col-6"
  }, logo), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-md-2 col-sm-6 col-6"
  }, hamburger))));
};

var _default = Header;
exports["default"] = _default;